import { render, staticRenderFns } from "./WrappedImage.vue?vue&type=template&id=3ebdeb3a&scoped=true&"
import script from "./WrappedImage.vue?vue&type=script&lang=ts&"
export * from "./WrappedImage.vue?vue&type=script&lang=ts&"
import style0 from "./WrappedImage.vue?vue&type=style&index=0&id=3ebdeb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebdeb3a",
  null
  
)

export default component.exports